module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_8017.f382ce1c.png";